
export enum ProcessRunMode {
    SCHEDULED = 2,
    STOPPED = 0
}
